import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const basePath = typeof __BASE_PATH__ !== 'undefined' ? __BASE_PATH__ : '';
const rawPath = window.location.pathname;
const normalizedPath = basePath && rawPath.startsWith(basePath)
  ? rawPath.slice(basePath.length) || '/'
  : rawPath;
(window as { __HOME_BOOTSTRAP__?: boolean }).__HOME_BOOTSTRAP__ =
  normalizedPath === '/' || normalizedPath === '';
(window as { __ARTISTS_BOOTSTRAP__?: boolean }).__ARTISTS_BOOTSTRAP__ =
  normalizedPath === '/artists';

createRoot(document.getElementById('root')!).render(
  <App />,
)
